import { scanLines } from "features/QueryConsole/components/Extensions/querySyntaxScan"
import { Token } from "features/Docs/types/docs.types"

/**
 * Static, pure highlighter for DATA(Q) Query snippets shown in docs.
 *
 * All of the language knowledge lives in querySyntaxScan, which the live
 * editor extension runs too — this file only turns the scanner's per-character
 * classes into `Token[]` runs. Uses the `syntax-*` classes, which docs.css
 * restates for the dark `.docs-code--query` panel.
 */

const coalesce = (line: string, classes: (string | undefined)[]): Token[] => {
  if (line.length === 0) return [{ text: "" }]
  const tokens: Token[] = []
  let start = 0
  for (let i = 1; i <= line.length; i++) {
    if (i === line.length || classes[i] !== classes[start]) {
      const className = classes[start]
      const text = line.slice(start, i)
      tokens.push(className ? { text, className } : { text })
      start = i
    }
  }
  return tokens
}

/**
 * Highlight a block of DATA(Q) Query text.
 * @returns one Token array per line.
 */
export const highlightQuery = (code: string): Token[][] => {
  const lines = code.split(/\r?\n/)
  return scanLines(lines).map((classes, index) =>
    coalesce(lines[index], classes)
  )
}

export default highlightQuery
